import { getToken, setToken, removeToken, setJsessionId } from '@/utils/auth'
const api = require('@/_app/' + process.env.PROJECT + '/src/api/login')

const loginByUsername = api.loginByUsername
const logout = api.logout
const getUserInfo = api.getUserInfo
const sendMobileMsg = api.sendMobileMsg
const getRetrievePassword = api.getRetrievePassword

const user = {
  state: {
    id: '',
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    menus: [],
    checkSessionUrl: '',
    imagePath: '',
    setting: {
      articlePlatform: []
    },
    regionLevel5Switch: ''
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_CHECKSESSIONURL: (state, checkSessionUrl) => {
      if(checkSessionUrl){
        state.checkSessionUrl = checkSessionUrl
      }
    },
    SET_WATERMARK: (state, imagePath) => {
      if(imagePath){
        state.imagePath = imagePath
      }
    },
    SET_REGIONLEVEL5SWITCH: (state, value) => {
      if(value){
        state.regionLevel5Switch = value
      }
    },
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(response => {
          if (response.code !== 0) {
            reject(response)
            return false
          }
          const data = response.data
          commit('SET_TOKEN', data.token)
          setToken(response.data.token)
          if (response.data.jsessionid) {
            setJsessionId(response.data.jsessionid)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        if(process.env.PROJECT  === 'wwka' && localStorage.getItem('userInfo')){ // 有值取缓存
            let response = JSON.parse(localStorage.getItem('userInfo'))
            const data = response.data
            commit('SET_ID', data.userId)
            commit('SET_ROLES', data.roles)
            commit('SET_NAME', data.name)
            commit('SET_AVATAR', data.avatar)
            commit('SET_INTRODUCTION', data.introduction)
            commit('SET_MENUS', data.menus)
            commit('SET_CHECKSESSIONURL', data.checkSessionUrl)
            commit('SET_WATERMARK', data.imagePath)
            commit('SET_REGIONLEVEL5SWITCH', data.regionLevel5Switch)
            resolve(response)
        }else
        getUserInfo(state.token).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            if (response.message) {
              reject(response.message)
            } else {
              reject('error')
            }
          }
          const data = response.data
          if(process.env.PROJECT  === 'wwka'){
            localStorage.setItem('userInfo',JSON.stringify(response))
          }
          commit('SET_ID', data.userId)
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          commit('SET_MENUS', data.menus)
          commit('SET_CHECKSESSIONURL', data.checkSessionUrl)
          commit('SET_WATERMARK', data.imagePath)
          commit('SET_REGIONLEVEL5SWITCH', data.regionLevel5Switch)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          localStorage.clear()
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        localStorage.clear()
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    },
    // 获取短信验证码
    sendMobileMsg({ commit },userInfo) {
      return new Promise((resolve, reject) => {
        sendMobileMsg(userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 忘记密码
    getRetrievePassword({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getRetrievePassword(userInfo.tel,userInfo.telcode,userInfo.fpwd,userInfo.fpwdret).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js